import { StyleguideCompanyType, StyleguidePageList, StyleguidePages, StyleguideProjectInfoType } from '../types'

const styleguideAllowedSlugs = StyleguidePageList

export function styleguideVerifyAllowedSlug(slug: StyleguidePages) {
  if (styleguideAllowedSlugs.indexOf(slug) >= 0) {
    return true
  }
  return false
}

export function styleguideGetCompanyInfo(company: StyleguideCompanyType) {
  if (company === 'hoppinger') {
    return {
      name: 'Hoppinger',
      url: 'https://www.hoppinger.com',
    }
  }
  return {
    name: 'Other',
    url: '',
  }
}

export function styleguideGetProjectInfo(project: StyleguideProjectInfoType) {
  if (project.name !== '') {
    return {
      name: project.name,
      logoSrc: project.logoSrc,
    }
  } else {
    return {
      name: 'Hoppinger',
      logoSrc: 'https://giustoragev2.blob.core.windows.net/shoppinger/logo-hds-white.svg',
    }
  }
}
